import React from "react";
import {
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack
} from "@chakra-ui/react";
import { ToolsConfig } from "duck";

interface WidthSliderProps {
  config: ToolsConfig;
}

const WidthSlider: React.FC<WidthSliderProps> = ({ config }) => {
  const { penWidth, updatePenWidth } = config;

  return (
    <Slider
      w={32}
      onChangeEnd={width => {
        updatePenWidth(width);
      }}
      min={2}
      step={2}
      max={16}
      aria-label="Width slider"
      defaultValue={penWidth}
    >
      <SliderTrack>
        <SliderFilledTrack />
      </SliderTrack>
      <SliderThumb boxSize={5} />
    </Slider>
  );
};

export default WidthSlider;
